import React from 'react';
import { TabItem, Tabs } from '@/components';

export type SettingsTabKey =
  'booking-schedule' | 'rent-escalation' | 'slack-mentions' | 'slack-channels';

const TABS: TabItem<SettingsTabKey>[] = [
  {
    key: 'booking-schedule',
    label: 'Jadwal Booking Handover',
    to: '/settings',
  },
  {
    key: 'rent-escalation',
    label: 'Eskalasi Rent',
    to: '/settings/rent-escalation',
  },
  {
    key: 'slack-mentions',
    label: 'Slack Mention',
    to: '/settings/alert-assignees',
  },
  {
    key: 'slack-channels',
    label: 'Slack Channel',
    to: '/settings/notification-channels',
  },
];

export interface SettingsTabsProps {
  active: SettingsTabKey;
}

/** The four settings screens share one sidebar entry; this is their tab row. */
export const SettingsTabs: React.FC<SettingsTabsProps> = ({ active }) => (
  <Tabs
    items={TABS}
    active={active}
    ariaLabel="Settings sections"
    className="mb-6"
  />
);

export default SettingsTabs;
